import React from "react";
import UserGreenIcon from "../../../Common/svg/usergreenicon";
import StatusBadge from "../../../UI/statusBadge";
import PaymentCardIcon from "../../../Common/svg/paymentCard";

const PaymentInfo = ({ payment_status, payment_method }) => {
  return (   
    <div className="col-md-4 ps-0">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center gap-2  mb-3">
            <PaymentCardIcon />
            <h5 className="text-smoke font16 font700">معلومات الدفع </h5>
          </div>
          <div>
            <h6 className="text-gray mb-1">حالة الدفع</h6>
            <StatusBadge
              status={payment_status.value === "unpaid" ? "inActive" : "active"}
              statusLabel={payment_status.value}
            />
            <h6 className="mb-1 mt-1 text-gray ">طريقة الدفع </h6>
           <div className="text-smoke"> {payment_method?.name}</div>  
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
